import React from 'react'
import { Modal} from 'react-bootstrap';
const Trailer = (props) => {
    const DetailMovies = props.data;
    return (
        <div>
            <Modal {...props} size="xl" centered aria-labelledby="contained-modal-title-vcenter" className="border-0">
                <Modal.Header className="bg-secondary border-0" closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        <h5 className="modal-title" id="trailerLabel">Trailer: {DetailMovies?.title}</h5>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="bg-dark rounded-bottom p-0" style={{ lineHeight: 0 }}>
                    <iframe width="100%" height="450" src={`https://www.youtube.com/embed/${DetailMovies?.yt_trailer_code}`} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default Trailer;